import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import Icon from "@cayuse/shared-react.components.icon";

import styles from "./styles.css";


const DashboardTile = forwardRef(({ icon, count, title, description, onClick, isSelected, dashboardTopic, ariaControls, tabIndex }, ref) => {
	const buttonClasses = `${styles.tile} ${isSelected ? styles.selected : ""}`;
	const ariaControlsAttribute = ariaControls ? { "aria-controls": ariaControls } : {};

	return (
		<button
			aria-label={`View ${count} ${dashboardTopic} ${title}`}
			aria-pressed={isSelected ? true : false}
			{...ariaControlsAttribute}
			className={buttonClasses}
			onClick={onClick}
			tabIndex={tabIndex}
			ref={ref}
		>
			<div className={styles.layout}>
				<div className={styles.body}>
					<div role="heading" aria-level="2"><span className={styles.count}>{count}</span>{title}</div>
					<div className={styles.description}>{description}</div>
				</div>
				<Icon className={styles.icon} size="huge" name={icon} />
			</div>
		</button>
	);
});

DashboardTile.propTypes = {
	icon: PropTypes.string,
	count: PropTypes.number,
	title: PropTypes.string,
	description: PropTypes.string,
	onClick: PropTypes.func,
	isSelected: PropTypes.bool,
	dashboardTopic: PropTypes.string,
	ariaControls: PropTypes.string,
	tabIndex: PropTypes.number
};

export default DashboardTile;
